import { makeStyles } from "@mui/styles";
import { createTheme } from "@mui/material/styles";

const theme = createTheme();

const useHeaderStyles = makeStyles(() => ({
  headerContainer: {
    width: "100%",
  },
  topBlueBar: {
    background: "#38aae9",
  },
  toolbarCenter: {
    justifyContent: "center",
  },
  clientLogoText: {
    fontWeight: "bold",
    "@media (max-width:600px)": {
      fontSize: "1.25rem",
    },
    "@media (min-width:601px)": {
      fontSize: "1.5rem",
    },
  },
  blackBar: {
    backgroundColor: "black",
    color: "yellow",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: "16px",
    paddingRight: "16px",
    flexWrap: "wrap",
    
  },
  blackBarContainer: {
    backgroundColor: "black",
    color: "yellow",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: "6px",
    paddingRight: "16px",
    paddingTop: "8px",
    paddingBottom: "8px",
    flexWrap: "wrap",
    width: "100%"
  },
  examTitle: {
    fontWeight: "bold",
  },
  iconsContainer: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    color: "white",
    paddingRight: "12px",
  },
  iconTextGroup: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    "&:hover": {
      textDecoration: "underline",
    },
    
  },
  instructionsIcon: {
    color: "white",
    cursor: "pointer",
    position:'relative',
    left:'30px',
    
  },
  questionpaperIcon: {
    color: "lightgreen",
  },
  instructionsDialogContent: {
    whiteSpace: "pre-line",
     "& img": {
      width: "100% !important",
      height: "auto !important",
      maxWidth: "100%", // Ensures responsiveness
    },
  },
  mobileMarginTop: {
    "@media (max-width:600px)": {
      marginTop: "8px",
    },
  },
}));

export default useHeaderStyles;